// Vuetify theme colors for the v2 look (see the design-tokens mockup this was signed off from).
// Applied at runtime the same way the existing dark-mode toggle swaps colors - see
// useAppConfig.js's `uiVersion` computed and @core/preset/preset/index.js's boot-time read.
// `background`/`surface`/`border` are extra custom color keys (Vuetify 2 supports adding
// arbitrary named colors beyond the standard primary/secondary/etc set). With
// `theme.options.customProperties: true` (already set in plugins/vuetify.js) these become
// `--v-background-base` / `--v-surface-base` / `--v-border-base` CSS custom properties that
// Vuetify itself keeps correctly scoped and dark/light-reactive - including inside portaled
// content like v-dialog, which plain DOM-ancestor CSS scoping can't reach. Reference those
// vars in _overrides.scss rather than hand-rolling separate light/dark color logic there.
// `primarysoft` (all-lowercase key, deliberately not camelCase) is a pre-computed light tint
// of primary, used for icon chips/hover fills - kept as an explicit color rather than
// computed via rgba()/color-mix() because primary is only available as a hex custom property
// (--v-primary-base), not an rgb triplet.
export default {
  light: {
    primary: '#5B4FE8',
    accent: '#5B4FE8',
    secondary: '#6B6B78',
    success: '#1A8754',
    info: '#5B4FE8',
    warning: '#B7791F',
    error: '#D14343',
    background: '#F9F8FE',
    surface: '#FFFFFF',
    border: '#E4E1F5',
    primarysoft: '#EEECFD',
  },
  dark: {
    primary: '#9C94FF',
    accent: '#9C94FF',
    secondary: '#A3A3B0',
    success: '#4CBF82',
    info: '#9C94FF',
    warning: '#D9A441',
    error: '#E37272',
    background: '#15131F',
    surface: '#1D1A2B',
    border: '#312C48',
    primarysoft: '#2C2660',
  },
}
